import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase";
import { normalizeEventRecord } from "./eventViewModel";

export async function getApprovedEventById(eventId) {
  if (!eventId) return null;

  const snapshot = await getDoc(doc(db, "events", eventId));
  if (!snapshot.exists()) return null;

  const data = snapshot.data();
  if (data.status !== "approved") return null;

  return normalizeEventRecord(snapshot.id, data);
}
